<template>
    <div>
        <v-card v-if="learner_fees_data != null">
            <div class="table-container">
                <table id="admitted-student-report" dense class="elevation-1" style="width: auto;">
                    <thead class="toolbar">
                        <tr>
                            <th>Sr. No.</th>
                            <th>PRN No</th>
                            <th>Name</th>
                            <th>Div</th>
                            <th>Roll No.</th>
                            <th>Admission Year</th>
                            <th v-for="header in component_headers" :key="header">
                                <center>{{ header }}</center>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in learner_fees_data" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{ item.learner_grno }}</td>
                            <td>{{ item.learner_name }}</td>
                            <td>{{ item.learner_division }}</td>
                            <td>{{ item.roll_no }}</td>
                            <td>{{ item.learner_addmission_year }}</td>
                            <td v-for="header in component_headers" :key="header">
                            <!-- {{item[header]}} -->
                            <span v-if="item[header]">
                                 <span v-if="item[header].paid_ammount != item[header].ammount" class="text-color">
                                    {{ item[header].paid_ammount }}/{{ item[header].ammount }}
                                </span>
                                <span v-else>{{ item[header].paid_ammount }}/{{ item[header].ammount }}</span> 
                            </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        props: {
            std_id: Number,
            ay_id: Number
        },
        data() {
            return {
                color: "",
                snackbar: false,
                overlay: false,
                search: "",
                learner_fees_data: null,
                standard: null,
                component_headers: null,
            };
        },
        watch: {
            std_id() {
                this.getData();
            },
            
            overlay(val) {
            val = () => {
                this.overlay = false;
            };
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.overlay = true
                this.learner_fees_data= null
                const formData = {
                    stdid: this.std_id,
                    ay_id: this.ay_id
                };
                axios
                    .post("/AccountingAndFees/getStdLearnerFees", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.overlay = false
                            console.log('tag', res.data.learner_fees_data)
                            this.learner_fees_data = res.data.learner_fees_data;
                            this.component_headers = res.data.component_headers;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        // alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.dataTable = $("#admitted-student-report").DataTable({
                            colReorder: true,
                            dom: "Bfrtip",
                            buttons: ["csvHtml5", "excelHtml5"],
                        });
                        this.overlay = false;
                        // alert(this.overlay)
                    });
            },
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .dt-button {
        font-size: 14px;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }
    .table-container {
        overflow-x: auto;
    }
    .paid {
        background: none;
    }
    .text-color {
        color: red;
    }
</style>
